import {
  IClientexdel,
  IDelegacion,
  IDetalleDemanda,
  IDetalleOferta,
  IDivisa,
  IParametro,
} from "@/entities";
import { ITransportadora } from "@/entities/centros-efectivo-backend/transportadora";

export interface IOfertaDemanda {
  cantidadDemandada?: number;
  cantidadDisponible: number;
  cantidadAplicada?: number;
  cantidadOfertada?: number;
  cantidadTransferida: number;
  checkAnonimo: boolean;
  checkParcial?: boolean;
  clientexdel: IClientexdel;
  divisa: IDivisa;
  transportadora?: ITransportadora;
  coste: IParametro;
  detallesDemanda?: IDetalleDemanda[];
  detallesOferta?: IDetalleOferta[];
  estado: string;
  fecCancelar?: string;
  fecCompleta?: string;
  fecCrear: string;
  fecExpirar?: string;
  fecModificacion?: string;
  id: number;
  numTasa?: number;
  observaciones?: string;
  cuentaCorriente: string;
  agNumeroSucursal: string;
  cnpjPersona: string;
  ispbBanco: string;
  ubicaciones?: IUbicacion[];
  isAllDelegations: boolean;
  isUpdatable?: boolean;
}

export interface IUbicacion {
  id: number;
  delegacion: IDelegacion;
}

export enum ActionOnOfertaDemanda {
  EDITAR = "editar",
  CREAR = "crear",
}
